module.exports = __webpack_public_path__ + "media/images/mv-a685c78b.jpg";